import { miz_videos } from './videos-json';

export function mizVideoFinder(paye: number, fasl: number, dars: number, ghesmat: number) {
  let str_paye: string = 'payeye' + paye
  let str_fasl: string = 'fasle' + fasl
  let str_dars: string = 'darse' + dars
  let str_ghesmat: string = 'ghesmate' + ghesmat

  return miz_videos[str_paye][str_fasl][str_dars][str_ghesmat];
}

export function count_tedadeDars(shomareyePaye: number, shomareyeFasl: number): number {
  let fasl = miz_videos['payeye'+shomareyePaye]['fasle'+shomareyeFasl];
  let countDars = 0;
  for (let key of Object.keys(fasl)){
    if (/darse\d+/.test(key)){
      countDars++;
    }
  }
  return countDars;
}

export function count_tedadeGhesmat(shomareyePaye: number, shomareyeFasl: number, shomareyeDars: number): number {
  let dars = miz_videos['payeye'+shomareyePaye]['fasle'+shomareyeFasl]['darse'+shomareyeDars];
  let countGhesmat = 0;
  for (let key of Object.keys(dars)){
    if (/ghesmate\d+/.test(key)){
      countGhesmat++;
    }
  }
  return countGhesmat;
}

export let videos_json = miz_videos;
